import { BotPreset } from '../enums/bot-preset.enum'

export interface BotPresetValues {
  confirmationTicks: number
  confirmationSeconds: number
  shiftPercentMin: number
  shiftPercentMax: number
  dropPercentMin: number
  dropPercentMax: number
}

// preset fills the dip-sensitivity fields only; peak strategy, cumulation, and
// staleness are orthogonal and keep their own config. MILD = avg(aggressive, conservative).
export const BOT_PRESETS: Record<BotPreset, BotPresetValues> = {
  [BotPreset.AGGRESSIVE]: {
    confirmationTicks: 1,
    confirmationSeconds: 0,
    shiftPercentMin: 0.2,
    shiftPercentMax: 1.0,
    dropPercentMin: 0.5,
    dropPercentMax: 2.0,
  },
  [BotPreset.MILD]: {
    confirmationTicks: 2,
    confirmationSeconds: 15,
    shiftPercentMin: 0.6,
    shiftPercentMax: 1.5,
    dropPercentMin: 1.25,
    dropPercentMax: 3.5,
  },
  [BotPreset.CONSERVATIVE]: {
    confirmationTicks: 3,
    confirmationSeconds: 30,
    shiftPercentMin: 1.0,
    shiftPercentMax: 2.0,
    dropPercentMin: 2.0,
    dropPercentMax: 5.0,
  },
}
